import { render, staticRenderFns } from "./AdminVideoVaultCard.vue?vue&type=template&id=aca00b24&scoped=true&"
import script from "./AdminVideoVaultCard.vue?vue&type=script&lang=ts&"
export * from "./AdminVideoVaultCard.vue?vue&type=script&lang=ts&"
import style0 from "./AdminVideoVaultCard.vue?vue&type=style&index=0&id=aca00b24&scoped=true&lang=less&"
import style1 from "./AdminVideoVaultCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca00b24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VBtn,VCard,VFadeTransition,VFileInput,VFlex,VHover,VLayout,VOverlay,VTextField,VTextarea})
